/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntityTypeEnum } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { NotePatchModel } from '../models';
/**
 * NoteApi - axios parameter creator
 * @export
 */
export const NoteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete note for an entity
         * @summary Delete note for an entity
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNote: async (entityType: EntityTypeEnum, entityId: string, noteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteEntityNote', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteEntityNote', 'entityId', entityId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('deleteEntityNote', 'noteId', noteId)
            const localVarPath = `/api/v1/fhir/note/{entityType}/{entityId}/{noteId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch note for an entity
         * @summary Patch note for an entity
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {NotePatchModel} notePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNote: async (entityType: EntityTypeEnum, entityId: string, notePatchModel: NotePatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('patchEntityNote', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('patchEntityNote', 'entityId', entityId)
            // verify required parameter 'notePatchModel' is not null or undefined
            assertParamExists('patchEntityNote', 'notePatchModel', notePatchModel)
            const localVarPath = `/api/v1/fhir/note/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notePatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NoteApi - functional programming interface
 * @export
 */
export const NoteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NoteApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete note for an entity
         * @summary Delete note for an entity
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityNote(entityType: EntityTypeEnum, entityId: string, noteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityNote(entityType, entityId, noteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.deleteEntityNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch note for an entity
         * @summary Patch note for an entity
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {NotePatchModel} notePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchEntityNote(entityType: EntityTypeEnum, entityId: string, notePatchModel: NotePatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchEntityNote(entityType, entityId, notePatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NoteApi.patchEntityNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NoteApi - factory interface
 * @export
 */
export const NoteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NoteApiFp(configuration)
    return {
        /**
         * Delete note for an entity
         * @summary Delete note for an entity
         * @param {NoteApiDeleteEntityNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityNote(requestParameters: NoteApiDeleteEntityNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEntityNote(requestParameters.entityType, requestParameters.entityId, requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch note for an entity
         * @summary Patch note for an entity
         * @param {NoteApiPatchEntityNoteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntityNote(requestParameters: NoteApiPatchEntityNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchEntityNote(requestParameters.entityType, requestParameters.entityId, requestParameters.notePatchModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NoteApi - interface
 * @export
 * @interface NoteApi
 */
export interface NoteApiInterface {
    /**
     * Delete note for an entity
     * @summary Delete note for an entity
     * @param {NoteApiDeleteEntityNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApiInterface
     */
    deleteEntityNote(requestParameters: NoteApiDeleteEntityNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Patch note for an entity
     * @summary Patch note for an entity
     * @param {NoteApiPatchEntityNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApiInterface
     */
    patchEntityNote(requestParameters: NoteApiPatchEntityNoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for deleteEntityNote operation in NoteApi.
 * @export
 * @interface NoteApiDeleteEntityNoteRequest
 */
export interface NoteApiDeleteEntityNoteRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof NoteApiDeleteEntityNote
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof NoteApiDeleteEntityNote
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof NoteApiDeleteEntityNote
     */
    readonly noteId: string
}

/**
 * Request parameters for patchEntityNote operation in NoteApi.
 * @export
 * @interface NoteApiPatchEntityNoteRequest
 */
export interface NoteApiPatchEntityNoteRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof NoteApiPatchEntityNote
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof NoteApiPatchEntityNote
     */
    readonly entityId: string

    /**
     * 
     * @type {NotePatchModel}
     * @memberof NoteApiPatchEntityNote
     */
    readonly notePatchModel: NotePatchModel
}

/**
 * NoteApi - object-oriented interface
 * @export
 * @class NoteApi
 * @extends {BaseAPI}
 */
export class NoteApi extends BaseAPI implements NoteApiInterface {
    /**
     * Delete note for an entity
     * @summary Delete note for an entity
     * @param {NoteApiDeleteEntityNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public deleteEntityNote(requestParameters: NoteApiDeleteEntityNoteRequest, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).deleteEntityNote(requestParameters.entityType, requestParameters.entityId, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch note for an entity
     * @summary Patch note for an entity
     * @param {NoteApiPatchEntityNoteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    public patchEntityNote(requestParameters: NoteApiPatchEntityNoteRequest, options?: RawAxiosRequestConfig) {
        return NoteApiFp(this.configuration).patchEntityNote(requestParameters.entityType, requestParameters.entityId, requestParameters.notePatchModel, options).then((request) => request(this.axios, this.basePath));
    }
}

